module.exports = __webpack_public_path__ + "static/media/CTLI_8-293w.f5d31793.jpg";